var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.adBlock)?_c('router-view'):_vm._e(),(_vm.adBlock)?_c('notification-modal',{staticClass:"ad-blk",attrs:{"hide-footer":true,"header-text":"Ad Blocker Detected","notification-msg":_vm.adBlock}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }